module.exports = __webpack_public_path__ + "img/slider-2.b668f6b.png";